import React from 'react'
import { ProductListMinimo } from '../components/ProductListMinimo';
import { useNightMenuData, useNightMenuDataWithSubCategory } from '../data/noche';
import { bebida } from '../data/bebida';
import { ProductListMinimoConPrecio } from '../components/ProductListMinimoConPrecio';
import { postre } from '../data/postre';

export const ComidaNight = () => {

    const itemsEntrante = useNightMenuData('Entrante');
    const itemsSushi = useNightMenuData('Sushi');
    const itemsCalientes = useNightMenuData('Calientes');
    const itemsFritos = useNightMenuData('Fritos');
    const itemsVapor = useNightMenuData('Vapor');
    const itemsPlancha = useNightMenuData('Plancha');

    const itemsNigiri = useNightMenuDataWithSubCategory('Sushi', 'nigiri');
    const itemsMaki   = useNightMenuDataWithSubCategory('Sushi', 'maki');
    const itemsSashimi = useNightMenuDataWithSubCategory('Sushi', 'sashimi');
    const itemsCombo = useNightMenuDataWithSubCategory('Sushi', 'combo');
    const itemsUramaki = useNightMenuDataWithSubCategory('Sushi', 'uramaki');
    const itemsHosofrito = useNightMenuDataWithSubCategory('Sushi', 'hosofrito');
    const itemsGunkan = useNightMenuDataWithSubCategory('Sushi', 'gunkan');
    const itemsTemaki = useNightMenuDataWithSubCategory('Sushi', 'temaki');
    const itemsOtros = useNightMenuDataWithSubCategory('Sushi', 'otros');

    const itemsBebida = bebida;
    const itemsPostre = postre;

  return (
    <div style={{
        backgroundColor: '#FFF',
        color: '#16213D',
        width: '98%',
        marginLeft: '1%',
        marginTop: '1%',
    }}>
        <h1> Entrantes </h1>
        <ProductListMinimo items={itemsEntrante} />

        <h1> Vapor </h1>
        <ProductListMinimo items={itemsVapor} />

        <h1> Fritos </h1>
        <ProductListMinimo items={itemsFritos} />

        <h1> Plancha </h1>
        <ProductListMinimo items={itemsPlancha} />

        <h1> Wok </h1>
        <ProductListMinimo items={itemsCalientes} />

        <h1> Nigiri </h1>
        <ProductListMinimo items={itemsNigiri} />

        <h1> Hosomaki </h1>
        <ProductListMinimo items={itemsMaki} />

        <h1> Uramaki </h1>
        <ProductListMinimo items={itemsUramaki} />

        <h1> Hosofrito </h1>
        <ProductListMinimo items={itemsHosofrito} />

        <h1> Gunkan </h1>
        <ProductListMinimo items={itemsGunkan} />

        <h1> Platos especiales </h1>
        <ProductListMinimo items={itemsSashimi.concat(itemsCombo).concat(itemsTemaki).concat(itemsOtros)} />
      {/* 
        <h1> Sushi </h1>
        <ProductListMinimo items={itemsSushi} />
      */}
        <h1> Bebida </h1>
        <ProductListMinimoConPrecio items={itemsBebida} />

        <h1> Postre </h1>
        <ProductListMinimoConPrecio items={itemsPostre} />
    </div>
  )
}
